export default __webpack_public_path__ + "static/char-s-54-ko-e0ef08a6f3a0284105c60cf4c42a75ee.webp";